import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e77fc8a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3e77fc8a&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e77fc8a')) {
      api.createRecord('3e77fc8a', component.options)
    } else {
      api.reload('3e77fc8a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e77fc8a", function () {
      api.rerender('3e77fc8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fileImg/index.vue"
export default component.exports